/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Image) GS.Toolbar.Image={};
GS.Toolbar.Image.GeometryTools=new Class({
    Extends: GS.Toolbar.Tools,
    class_name:'GS.Toolbar.Image.GeometryTools',
    options:{
        'wrapper': null,
        'class':'submenu full',
        'lexico':{'a':'Opacity','z':'Zoom','r':'Rotate','c':'Color','exd':'Extend to double spread','exs':'Extend to single spread','rh':'Reflex Horizzontal','rv':'Reflex Vertical','si': 'Split Image'},
        'toolbar':null,
        'min':0,
        'max':2
    },
    controlled:null,
    
    initialize:function(conf){
       this.options.lexico=Locale.get('Toolbar.geometry_menu');
       this.parent(conf);
    },

    attachToToolbarOLD: function(t){
        var self=this,w=this.options.wrapper,type=self.options.type;
        this.toolbar=t;
        this.register('no:selection',function(o,permission){
            //console.debug('Attach to:',o);
            self.controlled=o;
            if(!o) return;
            self.updatePermissions(permission);
        });

        this.register('active:frame',function(o,permission){
            //console.debug('Attach to:',o);
            self.controlled=o;
            if(!o) return;
            self.updatePermissions(permission);
        });

        this.register('toolbar:submenu',function(t) {
            console.debug('toolbar:submenu');
            if (w !== t) {
                w.removeClass('selected');
                if (this.sm) this.sm.setStyle('display', 'none');
            } else {
                if (this.sm) this.sm.fireEvent('show');
            }
        }.bind(this));

        this.register('toolbar:update:permissions', function (o) {
            console.debug('SHOW SUBMENU....', o);
            self.updatePermissions(o ? o.getPermissions() : {});
        });

        t.addEvent('submenu:show',function(t){
            console.debug('SHOW SUBMENU....');
            if(w!==t)  {
                w.removeClass('selected');
                if(this.sm) this.sm.setStyle('display','none');
            }else{

                //if(this.sm) this.sm.fireEvent('show');
                this.dispatch('toolbar:submenu', t);
            }
        }.bind(this));



        /* t.addEvent('linkedTo',function(o){
            self.controlled=o;
            if(!o) return;
            self.updatePermissions(o.getPermissions());
         });*/
        this.configureTools();
    }
});


GS.Toolbar.Image.GeometryTools.prototype.updatePermissions = function (p){
    //console.info('IMAGE TOOLS UPDATE PERMISSION...', p, this.sm, this.controlled);
    //this.parent(p);

    var zP, aP, rhP, rvP, si;

    if(!p.image){
        //console.warn('I\'AM HERE');
        this.sm.parentNode.style.display = 'none';
    }else{
        this.sm.parentNode.style.display = 'inline-block';
        //this.sm.style.display = 'inline-block';
        aP = this.sm ? this.sm.querySelector('[data-type="alpha"]') : null;
        zP = this.sm ? this.sm.querySelector('[data-type="zoom"]') : null;
        rhP = this.sm ? this.sm.querySelector('[data-type="reflect-h"]') : null;
        rvP = this.sm ? this.sm.querySelector('[data-type="reflect-v"]') : null;
        si = this.sm ? this.sm.querySelector('[data-type="split-image"]') : null;
        if(aP) aP.style.display = 'inline-block';
        if(zP) zP.style.display = 'inline-block';
        if(rhP) rhP.style.display = 'inline-block';
        if(rvP) rvP.style.display = 'inline-block';
        if(si) si.setAttribute('hidden',true);

        if(zP && p.image && !p.image.zoom) zP.style.display = 'none';
        if(aP && p.image && !p.image.alpha) aP.style.display = 'none';
        if(si && p.image && p.image.split_image && window.getCustomerCode && window.getCustomerCode() === 0) {
            si.removeAttribute('hidden',true);
            si.querySelector('input').checked = this.controlled.splitNode;
        }
        if(rhP && p.image && !p.image.reflect) {
            rhP.style.display = 'none';
            rvP.style.display = 'none';
        }
    }


}

/**
     * 
     * @param {Object} permissions
     * @returns {void}
     */
/*GS.Toolbar.Image.GeometryTools.prototype.updatePermissions=function(permissions){
        var vis=false,
            self=this,
            use=this.options.permission_property;

        if(!use.pop) use=[use];
        
        Array.each(use,function(prop,i){
            
            if(typeof permissions[prop]==='object'){
                Object.each(permissions[prop],function(v,p){
                    console.debug('Property: %s, value: %s',prop,v);
                    if(v) vis=true;
                    self.fireEvent(p,v);
                });
            }else{
                if(permissions[prop]===true) vis=true;
                self.fireEvent(prop,permissions[prop]);
            }
        });
        this.options.wrapper.setStyle('display',(vis) ? 'block' : 'none');
        if(vis) this.toolbar.fireEvent('show');
    };*/


GS.Toolbar.Image.GeometryTools.prototype.menuTMPL=function(){
   var out='';
    //out+='      <li class="background-color" title="{c}" data-type="background-color" data-uitype="colorpicker" id="toolbar-background-color"><div class="color-placeholder bg"></div></li>';
    /*out+='      <li class="separetor"></li>';
    out+='      <li class="fit-c-horizontal" title="{exd}" data-type="fit-c-horizontal"></li>';
    out+='      <li class="separetor"></li>';
    out+='      <li class="fit-c-vertical" title="{exs}" data-type="fit-c-vertical"></li>';
    out+='      <li class="separetor"></li>';*/

    //out+='      <li class="separetor-h"></li>';
    out+='      <li class="slider zoom" data-type="zoom" data-uitype="slider_w_input"><label class="min">{zMin}</label><label>{z}</label><label class="max">{zMax}</label></li>';
    out+='      <li class="separator-h"></li>';
    out+='      <li class="slider alpha" data-type="alpha" data-uitype="slider_w_input"><label class="min">{aMin}</label><label>{a}</label><label class="max">{aMax}</label></li>';
    out+='      <li class="separator-h"></li>';
    out+='      <li class="reflect-h" title="{rh}" data-type="reflect-h"></li>';
    out+='      <li class="separator"></li>';
    out+='      <li class="reflect-v" title="{rv}" data-type="reflect-v"></li>';
    out+=`      <li class="split-image" title="${this.options.lexico.si || 'Split Image'}" data-uitype="toggler" data-type="split-image" hidden>
                    <label class="toggle">
                        <input class="toggle-checkbox" type="checkbox">
                        <div class="toggle-switch"></div>
                        <span class="toggle-label">${this.options.lexico.si || 'Split Image'}</span>
                    </label>
    </li>`;
    //out+='      <li class="slider shadow-color" data-type="framebg-color"  id="toolbar-framebg-color" data-uitype="colorpicker"><div class="color-placeholder"  title="{tooltip_c}"></div></li>';
    //out+='      <li class="separetor-h"></li>';
    //out+='      <li class="slider rotate" data-type="rotate" data-uitype="slider"><label>{r}</label></li>';
    
    return out;
};